import styles from 'components/notifications/notification.module.css';
import { CrossIcon } from 'components/vectors/CrossIcon';
import { INotificationText } from 'components/contactForm/ContactForm';

interface INotificationPros {
    icon: JSX.Element;
    isNotificationOpen: boolean;
    setIsNotificationOpen: (_val: boolean) => void;
    notificationText?: INotificationText;
}

export const Notification = ({
    icon,
    isNotificationOpen,
    setIsNotificationOpen,
    notificationText,
}: INotificationPros) => {
    const closeNotification = () => {
        setIsNotificationOpen(!isNotificationOpen);
    };

    if (!isNotificationOpen) {
        return null;
    }

    return (
        <div className={styles.notification}>
            <div
                className={styles.notification__closeIcon}
                onClick={closeNotification}
            >
                <CrossIcon />
            </div>
            <div className={styles.notification__header}>
                <div className={styles.notification__statusIcon}>{icon}</div>

                <h4 className={styles.notification__title}>
                    {notificationText?.titleText}
                </h4>
            </div>

            <p className={styles.notification__desc}>
                {notificationText?.descText}
            </p>
        </div>
    );
};
